import React from "react";
import Plot from "react-plotly.js";

const RadarChart = ({ termName, similarities, status }) => {
  // Mapear los datos de similitud según la estructura de sourceLEL
  // "Tipo" se agrega como eje propio siguiendo la última versión del notebook,
  // donde la similitud de tipo pasó a formar parte del radar.
  // Los 10 ejes del notebook del autor, en su mismo orden (agrupados por
  // técnica: TF-IDF, N-gram y Semántico):
  //   ['Tipo', 'Nombre (TF-IDF)', 'Nociones (TF-IDF)', 'Impactos (TF-IDF)',
  //    'Nombre (N-gram)', 'Nociones (N-gram)', 'Impactos (N-gram)',
  //    'Nombre (Semántico)', 'Nociones (Semántico)', 'Impactos (Semántico)']
  const labels = [
    "Tipo",
    "Nombre (TF-IDF)",
    "Nociones (TF-IDF)",
    "Impactos (TF-IDF)",
    "Nombre (N-gram)",
    "Nociones (N-gram)",
    "Impactos (N-gram)",
    "Nombre (Semántico)",
    "Nociones (Semántico)",
    "Impactos (Semántico)",
  ];

  // Convertir las similitudes a porcentajes (0-100)
  const pct = (v) => (typeof v === "number" && !Number.isNaN(v) ? v * 100 : 0);
  const values = [
    pct(similarities.type_similarity),
    pct(similarities.nombre_tfidf_sim),
    pct(similarities.nociones_tfidf_sim),
    pct(similarities.impactos_tfidf_sim),
    pct(similarities.nombre_ngram_sim),
    pct(similarities.nociones_ngram_sim),
    pct(similarities.impactos_ngram_sim),
    pct(similarities.nombre_emb_sim),
    pct(similarities.nociones_emb_sim),
    pct(similarities.impactos_emb_sim),
  ];

  // Cerrar el polígono agregando el primer valor al final
  const theta = [...labels, labels[0]];
  const r = [...values, values[0]];

  // Color según el estado, con la paleta de estados LEL del resto de la app
  // (celeste -> azul).
  const getColorByStatus = (status) => {
    switch (status?.toLowerCase()) {
      case 'similitud':
        return {
          fillcolor: "rgba(0, 0, 139, 0.3)", // #00008B
          lineColor: "rgb(0, 0, 139)",
          markerColor: "rgb(0, 0, 139)"
        };
      case 'diferencia':
        return {
          fillcolor: "rgba(30, 144, 255, 0.3)", // #1E90FF
          lineColor: "rgb(30, 144, 255)",
          markerColor: "rgb(30, 144, 255)"
        };
      case 'no similitud':
        return {
          fillcolor: "rgba(203, 213, 225, 0.4)", // #CBD5E1
          lineColor: "rgb(100, 116, 139)",
          markerColor: "rgb(100, 116, 139)"
        };
      case 'omisión':
      case 'omision':
        return {
          fillcolor: "rgba(135, 206, 250, 0.35)", // #87CEFA
          lineColor: "rgb(43, 127, 168)",
          markerColor: "rgb(43, 127, 168)"
        };
      default:
        return {
          fillcolor: "rgba(30, 144, 255, 0.3)",
          lineColor: "rgb(30, 144, 255)",
          markerColor: "rgb(30, 144, 255)"
        };
    }
  };

  const colors = getColorByStatus(status);

  const data = [
    {
      type: "scatterpolar",
      r: r,
      theta: theta,
      fill: "toself",
      fillcolor: colors.fillcolor,
      line: {
        color: colors.lineColor,
        width: 2,
      },
      marker: {
        color: colors.markerColor,
        size: 6,
      },
      name: termName,
    },
  ];

  const layout = {
    polar: {
      radialaxis: {
        visible: true,
        range: [0, 100],
        ticksuffix: "%",
        tickfont: {
          size: 10,
        },
      },
      angularaxis: {
        tickfont: {
          size: 11,
        },
      },
    },
    showlegend: false,
    title: {
      text: `Análisis de Similitud: ${termName}`,
      font: {
        size: 12,
        family: "Arial, sans-serif",
      },
    },
    margin: {
      l: 40,
      r: 40,
      t: 40,
      b: 20,
    },
    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "rgba(0,0,0,0)",
  };

  const config = {
    displayModeBar: false,
    responsive: true,
    staticPlot: true, // Hace el gráfico completamente estático
    scrollZoom: false,
    doubleClick: false,
    showTips: false,
    displaylogo: false,
    modeBarButtonsToRemove: ['pan2d', 'select2d', 'lasso2d', 'zoom2d', 'zoomIn2d', 'zoomOut2d', 'autoScale2d', 'resetScale2d'],
  };

  return (
    <div className="w-full h-full">
      <Plot
        data={data}
        layout={layout}
        config={config}
        style={{ width: "100%", height: "100%" }}
        useResizeHandler={true}
      />
    </div>
  );
};

export default RadarChart;
